import styled from '@emotion/styled'

export interface StepHeaderProps {
  headline: string
  tagline?: string
  description?: string
}

export default function StepHeader({ headline, tagline, description }: StepHeaderProps) {
  return (
    <Root>
      <LeftCol>
        <Headline>{headline}</Headline>
        {description && <Description>{description}</Description>}
      </LeftCol>
      {tagline && <Tagline>{tagline}</Tagline>}
    </Root>
  )
}

const Root = styled.div`
  gap: 16px;
  display: flex;
  flex-direction: row;
`

const LeftCol = styled.div`
  flex: 1;
`

const Tagline = styled.div`
  padding: 4px 8px;
  background: #333;
`

const Headline = styled.div`
  font-weight: 700;
  font-size: 28px;
  text-align: center;
`

const Description = styled.div`
  color: #777;
`
